import { type JSX } from 'react'

import { useIsWideLayout } from '@hooks/useMediaQuery'

interface ShellProps {
  search: JSX.Element
  map: JSX.Element
}

function ProductFinderShell({ search, map }: ShellProps) {
  const isWideLayout = useIsWideLayout()

  if (!isWideLayout) {
    return (
      <div className='relative flex flex-1 flex-col'>
        {search}
      </div>
    )
  }

  return (
    <div className='flex w-full flex-1 flex-row'>
      <div className="relative flex w-3/8 flex-col border-r-2 border-border-secondary pr-2 xl:w-1/4">
        {search}
      </div>

      <div className="w-5/8 xl:w-3/4">
        {map}
      </div>
    </div>
  )
}

export default ProductFinderShell